
import Vue from "vue";

import { NolaAnalytics } from "@/lib/utils/analytics";

export default Vue.extend({
  props: {
    title: String,
    description: String,
  },
  data() {
    return {
      nolaAnalytics: new NolaAnalytics(this.$gtm, this.$store),
    };
  },
  methods: {
    onSubscriptionLinkClick() {
      this.nolaAnalytics.logCustomEvent("subscription_link_click", {
        source: "premium_feature_introduce",
      });
      this.$router.push({ name: "subscriptionAnnounce" });
    },
  },
});
